import { DoctorProfile } from '../store/types/prescription';
import { GET_DOCTOR_AUTO_SUGGEST } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

type Response = {
    success: boolean;
    data: DoctorResponse[];
};

export type DoctorResponse = {
    name?: string;
    major_specialisation?: string;
    s_id?: string;
    image?: {
        pic: string;
        pic_small: string;
    };
    gender?: string;
    slug?: string;
    title?: string;
    invite_code?: string;
    url?: string;
    id?: string;
    oid: string;
    profile?: DoctorProfile;
    type?: 'doctor' | 'speciality';
};

export default (searchString: string): Promise<Response> => {
    return fetchWithRefresh(GET_DOCTOR_AUTO_SUGGEST(searchString), {
        method: 'GET',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to fetch current time from api');
        }
    });
};
